import * as Redux from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import * as Reducers from './reducers'

const rootReducer = Redux.combineReducers({
  shell: Reducers.Shell.reducer,
  auth: Reducers.Auth.reducer,
  dashboard: Reducers.Dashboard.reducer,
  accessGraph: Reducers.AccessGraph.reducer,
  monitoring: Reducers.Monitoring.reducer,
  guardrails: Reducers.Guardrails.reducer,
  objects: Reducers.Objects.reducer,
  identities: Reducers.Identities.reducer,
  alerts: Reducers.Alerts.reducer,
  changes: Reducers.Changes.reducer,
  filter: Reducers.Filter.reducer,
  privileges: Reducers.Privileges.reducer,
  privilegesSummary: Reducers.PrivilegesSummary.reducer,
  policies: Reducers.Policies.reducer,
  externalLists: Reducers.ExternalLists.reducer,
  userUsage: Reducers.UserUsage.reducer,
  suite: Reducers.Suite.reducer,
  rule: Reducers.Rule.reducer,
  networks: Reducers.Networks.reducer,
  autocomplete: Reducers.Autocomplete.reducer,
  unusedAccess: Reducers.UnusedAccess.reducer,
  organization: Reducers.Organization.reducer,
  reports: Reducers.Reports.reducer
})

export type State = ReturnType<typeof rootReducer>

export type DefaultState = Partial<State>

export function configureStore(
  defaultState: DefaultState = {} as DefaultState
): Redux.Store<State> {
  const middlewares = [thunkMiddleware]
  const middlewareEnhancer = Redux.applyMiddleware(...middlewares)
  const enhancers = [middlewareEnhancer]
  const composedEnhancers = composeWithDevTools(...enhancers)

  return Redux.createStore(rootReducer, defaultState, composedEnhancers)
}

export const store = configureStore()
